import { Link } from 'react-router-dom';
import { Menu, Bell } from 'lucide-react';
import { useAuth } from '../../utils/Auth/AuthProvider';
import { useAlertsInbox } from '../../school_panel/api/hooks';
import ThemeToggle from './ThemeToggle';
import { TOPBAR_SLOT_ID } from './TopBarActions';
import ViewAsSwitch from './ViewAsSwitch';
import GlobalSearch from './GlobalSearch';

interface Props { sidebarOpen: boolean; setSidebarOpen: (b: boolean) => void }

export default function Header({ sidebarOpen, setSidebarOpen }: Props) {
  const { role } = useAuth();
  const isPanelUser = role === 'school_admin' || role === 'teacher' || role === 'counselor' || role === 'school' || role === 'admin';
  const inbox = useAlertsInbox({});
  const open = isPanelUser ? inbox.data?.results.length ?? 0 : 0;

  return (
    <header role="banner" className="flex flex-wrap items-center gap-2.5 pb-[30px] pt-5">
      <button type="button" aria-label="Open menu" aria-expanded={sidebarOpen}
        onClick={(e) => { e.stopPropagation(); setSidebarOpen(!sidebarOpen); }}
        className="grid h-11 w-11 place-items-center rounded-[12px] border border-line-strong bg-surface p-0 text-ink lg:hidden">
        <Menu size={18} strokeWidth={1.8} />
      </button>
      <GlobalSearch />
      <span className="hidden flex-1 sm:block" />
      {role === 'teacher' && <ViewAsSwitch />}
      <div id={TOPBAR_SLOT_ID} className="contents" />
      <ThemeToggle />
      {isPanelUser && (
        <Link to="/alerts" aria-label={`Alerts, ${open} open`}
          className="relative grid h-11 w-11 place-items-center rounded-[12px] border border-line-strong bg-surface text-ink hover:bg-surface-2">
          <Bell size={18} strokeWidth={1.8} />
          {open > 0 && <span className="absolute right-[11px] top-[10px] h-2 w-2 rounded-full border-2 border-white bg-alert-dot" />}
        </Link>
      )}
    </header>
  );
}
